module.exports = __webpack_public_path__ + "teqbahn-assets/media/1.e8843f89.jpg";